<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <RubiksCube />
</template>

<script>
import RubiksCube  from './components/RubiksCube.vue'

export default {
  name: 'App',
  components: {
    RubiksCube 
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
